import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import useTranslations from '@hooks/useTranslation';
import moment from 'moment';
import { RowTime, Time } from './ConferenceProgram.elements';

interface ConferenceProps {
    from?: string;
    to?: string;
}

const ConferenceProgramTimeTemplate: FC<ConferenceProps> = ({ from, to }) => {
    const { t } = useTranslations();

    const [newFrom, setFrom] = useState('');
    const [newto, setTo] = useState('');

    useEffect(() => {
        setFrom(from);
        setTo(to);
    }, [from, to]);

    return (
        <RowTime>
            {newFrom && (
                <>
                    <Time>{moment(newFrom).format('HH:mm')}</Time>
                    {newto && <Time> - </Time>}

                    {newto && <Time>{moment(newto).format('HH:mm')}</Time>}

                    <Time> hod.</Time>
                </>
            )}
        </RowTime>
    );
};

export default ConferenceProgramTimeTemplate;
